import { render, staticRenderFns } from "./Form3CaseInformation.vue?vue&type=template&id=9ba4c872&scoped=true"
import script from "./Form3CaseInformation.vue?vue&type=script&lang=ts"
export * from "./Form3CaseInformation.vue?vue&type=script&lang=ts"
import style0 from "./Form3CaseInformation.vue?vue&type=style&index=0&id=9ba4c872&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba4c872",
  null
  
)

export default component.exports